import { getAxiosBackendApi } from "../helpers/axios"

class StudentServices{

    constructor(){
    }

    addStudent(data){
        return getAxiosBackendApi().post('student', data)
    }

    getStudentByPhoneNumber(data){
        return getAxiosBackendApi().get('student', {params:data})
    }
}

export default new StudentServices()